module.exports = __webpack_public_path__ + "static/media/UF.fe90f703.png";